import React, { useState, useEffect, useCallback } from "react";
import {
    Grid,
    List,
    Button,
    ListItem,
    makeStyles,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import FormHeader from "../../../../Components/FormHeader";
import DatePicker from 'react-date-picker';
import SaveIcon from '@material-ui/icons/Save';
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import CancelIcon from '@material-ui/icons/Cancel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


/** Third party dependencies */
import html2canvas from 'html2canvas';


/** Local dependencies & Libraries */
import Services from '../../../../Services';

import { helpers } from '../../../../helpers';

import { Imports } from '../../../../Imports';

import Snackbar from '../../../../Components/Snackbar';
import TextArea from "antd/lib/input/TextArea";
import { formatSSN } from "../../../../Components/dummyConstant/DummyConstant";
import { getImageUrl } from "../../../../helpers/getImageUrl";
import { documentSubmit } from "../../../../helpers/api";


const {
    users,
    hr,
    Storage,
} = Services;

const {
    showSnackBar,
    getGenerator,
} = helpers;

const {
    styles: {
        displayNoneStyles: useStyles
    }
} = Imports;


const CompanyPropertyReturn = () => {

    const storage = new Storage();

    const classes = useStyles();
    const [adminData, setAdminData] = useState(null)

    const [formData, setFormData] = useState({
        firstName: '',
        middleName: '',
        lastName: '',
        socialSecurity: "",
        Comments: "",
        applicantSign: "",
        1: { equipment: "", newUsed: "", priceItem: '', employeeInitials: '', returndate: new Date() },
        2: { equipment: "", newUsed: "", priceItem: '', employeeInitials: '', returndate: new Date() },
        3: { equipment: "", newUsed: "", priceItem: '', employeeInitials: '', returndate: new Date() },
        4: { equipment: "", newUsed: "", priceItem: '', employeeInitials: '', returndate: new Date() },
        5: { equipment: "", newUsed: "", priceItem: '', employeeInitials: '', returndate: new Date() },
        signatureDate: new Date()
    })

    useEffect(async () => {
        let userProfile = await JSON?.parse(localStorage?.user_profile);
        setAdminData(userProfile)

        let res = await hr?.getAllApplicantsByIDApplicantLogin({ id: userProfile?.id })



        let data = {
            firstName: res?.employee?.firstName || '',
            middleName: res?.employee?.middleName || '',
            lastName: res?.employee?.lastName || '',
            socialSecurity: formatSSN(res?.employee?.ssn) || '',
            applicantSign: res?.AEmployee?.firstName + " " + res?.AEmployee?.lastName || '',


        }
        setFormData(prev => ({ ...prev, ...data }))
        // let userProfile = await JSON?.parse(localStorage?.user_profile);

        const { payDetails } = localStorage;

    }, [])


    const [isPosting, setPosting] = useState(false);
    const access = localStorage.getItem("access_jwt") || null
    const history = useHistory()

    async function submit() {

        let data = {
            signature: document.getElementById("employeeSignature").value
        }
        documentSubmit(setPosting, data, 20, [], access, history)

    }

    return (
        <Grid container xs={12} className="LiqForms-Container">
            <Snackbar></Snackbar>
            {/* <FormHeader/> */}
            <Grid className={isPosting ? classes.DisplayNone : 'FormsHeader'}>
                <List>
                    <ListItem>
                        <Grid className="FormMenuLogo"></Grid>
                    </ListItem>
                    <ListItem>
                        <Button onClick={submit}>
                            <SaveIcon />
                        </Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => window.print()}>
                            <LocalPrintshopIcon />
                        </Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => window.close()}>
                            <CancelIcon />
                        </Button>
                    </ListItem>
                </List>
            </Grid>
            <table id="tablePrint" className="MainTable capture">
                <tr className="w100">
                    <td className="w100">
                        <table className="SecondMainTable">
                            <tr className="w100">
                                <td className="w100">
                                    <table className="w100">
                                        <tbody className="w100">
                                            <tr className="w100 row justify-between">
                                                <td>
                                                    <div className="PreEmploymentFile">
                                                        PERSONNEL FILE
                                                    </div>
                                                </td>
                                                <td className=" justify-center" style={{ width: '60%' }}>
                                                    {/* <div className="TGSLogo"></div> */}
                                                    <div className="logoImageTGS"></div>
                                                </td>
                                            </tr>
                                            <tr className="w100">
                                                <td colspan="2" className="w100 header font16  textCenter">Company Propety Return Agreement</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </table>


                        <table className="w100" style={{ marginTop: '10px' }}>
                            <tbody className="w100">

                                <tr className="width100 row">
                                    <td className="w80 row"><p style={{ width: '80%', paddingTop: '12px' }}>Employee Name</p>
                                        <input type="text" name="officersName" id="officersName" className="w100 bn bb input-capitalization"
                                            value={
                                                `${formData?.firstName} ${formData?.lastName}`
                                            }
                                            disabled
                                        />
                                    </td>

                                </tr>
                                <tr className="width100 row">
                                    <td className="w80 row"><p style={{ width: '80%', paddingTop: '12px' }}>Social Security #</p>
                                        <input type="text" name="textfield" id="position" className="w100 bn bb input-capitalization"
                                            value={
                                                `${formData?.socialSecurity}`
                                            }
                                            disabled
                                        />
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                        <table className="" style={{ width: '80%', margin: 'auto', marginTop: '20px' }}>
                            <tbody>

                                <tr >


                                    <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} >I hereby accept the responsibility for all property issued to me throughout the course of my employment with Trans-
                                        Global Solutions, Inc. (TGS).</td>
                                </tr>
                                <tr >
                                    <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} >I understand that I am required to return all company property upon request or at termination of employment. I
                                        authorize TGS to deduct from my final pay check, in accordance with State and Federal laws, the cost of any items
                                        lost and/or not returned by me or returned in in a damaged or unacceptable condition.</td>
                                </tr>
                                <tr >
                                    <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} >I authorize TGS to take any and all necessary action to recover and protect its property.</td>

                                </tr>
                            </tbody>
                        </table>
                        <table style={{ margin: 'auto' }}>
                            <tr className="w100">
                                <td colspan="2" className="w100  font16  textCenter">EQUIPMENT ISSUED</td>
                            </tr>
                        </table>
                        <table style={{ width: '80%', border: '1px solid black', tableLayout: 'fixed', margin: 'auto', }}>

                            <tr className="bor">
                                <td contenteditable="false" className="bor bold"
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['1']: { ...prev['1'], equipment: e.target.value } }))}
                                    value={formData['1']?.equipment}>
                                    Equipment
                                </td>
                                <td contenteditable="false" className="bor bold"
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['1']: { ...prev['1'], newUsed: e.target.value } }))}
                                    value={formData['1']?.newUsed}
                                >
                                    New/Used
                                </td>
                                <td contenteditable="false" className="bor bold"
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['1']: { ...prev['1'], priceItem: e.target.value } }))}
                                    value={formData['1']?.priceItem}
                                >
                                    Price of Item</td>
                                <td contenteditable="false" className="bor bold"
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['1']: { ...prev['1'], employeeInitials: e.target.value } }))}
                                    value={formData['1']?.employeeInitials}>
                                    Employee Initials</td>
                                <td contenteditable="false" className="bor bold"
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['1']: { ...prev['1'], returndate: e.target.value } }))}
                                    value={formData['1']?.returndate}>
                                    Return Date
                                </td>

                            </tr>
                            <tr className="bor">
                                <td contenteditable="false" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['2']: { ...prev['2'], equipment: e.target.value } }))}
                                    value={formData['2']?.equipment}>
                                    Hardhat
                                </td>
                                <td contenteditable="false" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['2']: { ...prev['2'], newUsed: e.target.value } }))}
                                    value={formData['2']?.newUsed}
                                >
                                    New
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['2']: { ...prev['2'], priceItem: e.target.value } }))}
                                    value={formData['2']?.priceItem}
                                >
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['2']: { ...prev['2'], employeeInitials: e.target.value } }))}
                                    value={formData['2']?.employeeInitials}>
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['2']: { ...prev['2'], returndate: e.target.value } }))}
                                    value={formData['2']?.returndate}>

                                </td>

                            </tr>
                            <tr className="bor">
                                <td contenteditable="false" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['3']: { ...prev['3'], equipment: e.target.value } }))}
                                    value={formData['3']?.equipment}>
                                    Boots
                                </td>
                                <td contenteditable="false" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['3']: { ...prev['3'], newUsed: e.target.value } }))}
                                    value={formData['3']?.newUsed}
                                >
                                    New
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['3']: { ...prev['3'], priceItem: e.target.value } }))}
                                    value={formData['3']?.priceItem}
                                >
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['3']: { ...prev['3'], employeeInitials: e.target.value } }))}
                                    value={formData['3']?.employeeInitials}>
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['3']: { ...prev['3'], returndate: e.target.value } }))}
                                    value={formData['3']?.returndate}>
                                </td>

                            </tr>

                            <tr className="bor">
                                <td contenteditable="false" className="bor"
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], equipment: e.target.value } }))}
                                    value={formData['4']?.equipment}>
                                    Vest
                                </td>
                                <td contenteditable="false" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], newUsed: e.target.value } }))}
                                    value={formData['4']?.newUsed}
                                >
                                    New
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], priceItem: e.target.value } }))}
                                    value={formData['4']?.priceItem}
                                >
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], employeeInitials: e.target.value } }))}
                                    value={formData['4']?.employeeInitials}>
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], returndate: e.target.value } }))}
                                    value={formData['4']?.returndate}>

                                </td>

                            </tr>

                            <tr className="bor">
                                <td contenteditable="true" className="bor"
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], equipment: e.target.value } }))}
                                    value={formData['4']?.equipment}>

                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], newUsed: e.target.value } }))}
                                    value={formData['4']?.newUsed}
                                >

                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], priceItem: e.target.value } }))}
                                    value={formData['4']?.priceItem}
                                >
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], employeeInitials: e.target.value } }))}
                                    value={formData['4']?.employeeInitials}>
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], returndate: e.target.value } }))}
                                    value={formData['4']?.returndate}>

                                </td>

                            </tr>
                            <tr className="bor">
                                <td contenteditable="true" className="bor"
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], equipment: e.target.value } }))}
                                    value={formData['4']?.equipment}>

                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], newUsed: e.target.value } }))}
                                    value={formData['4']?.newUsed}
                                >

                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], priceItem: e.target.value } }))}
                                    value={formData['4']?.priceItem}
                                >
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], employeeInitials: e.target.value } }))}
                                    value={formData['4']?.employeeInitials}>
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], returndate: e.target.value } }))}
                                    value={formData['4']?.returndate}>

                                </td>

                            </tr>
                            <tr className="bor">
                                <td contenteditable="true" className="bor"
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], equipment: e.target.value } }))}
                                    value={formData['4']?.equipment}>

                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], newUsed: e.target.value } }))}
                                    value={formData['4']?.newUsed}
                                >

                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], priceItem: e.target.value } }))}
                                    value={formData['4']?.priceItem}
                                >
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], employeeInitials: e.target.value } }))}
                                    value={formData['4']?.employeeInitials}>
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], returndate: e.target.value } }))}
                                    value={formData['4']?.returndate}>

                                </td>

                            </tr>
                            <tr className="bor">
                                <td contenteditable="true" className="bor"
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], equipment: e.target.value } }))}
                                    value={formData['4']?.equipment}>

                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], newUsed: e.target.value } }))}
                                    value={formData['4']?.newUsed}
                                >

                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], priceItem: e.target.value } }))}
                                    value={formData['4']?.priceItem}
                                >
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], employeeInitials: e.target.value } }))}
                                    value={formData['4']?.employeeInitials}>
                                </td>
                                <td contenteditable="true" className="bor "
                                    onChange={(e) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], returndate: e.target.value } }))}
                                    value={formData['4']?.returndate}>

                                </td>

                            </tr>

                        </table>

                        <table className="w100" style={{ marginTop: '20px' }}>
                            <tbody className="w100">

                                <tr className="width100 row" style={{ marginBottom: '20px' }}>
                                    <td className="row" style={{ width: '90%' }}><p style={{ width: '70%' }}>Comments / Notes</p>
                                        {/* <input type="text" name="officersName" id="officersName" className="w100 bn bb input-capitalization" /> */}
                                        <TextArea rows="4" style={{ border: '1px solid black' }} />

                                    </td>

                                </tr>


                                <tr className="w80 row" style={{ margin: 'auto' }}>
                                    <td className="w80" style={{ border: '2px solid lightblue', display: 'flex', flexDirection: 'row', padding: '20px' }}>
                                        <p style={{ margin: '', width: '180px' }}>  Employee Signature :</p>
                                        <input type="text" id="employeeSignature" name="textfield"

                                            className="w56 bn bb signatureClass font-20"
                                        />
                                    </td>
                                </tr>
                                <tr className="w80 row" style={{ margin: 'auto' }}>
                                    {/* <p style={{ margin: 'auto' }}>Date</p> */}
                                    <td className="w80" style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}>
                                        <p style={{ marginTop: '10px', width: '300px' }}>  Company Representative:</p>

                                        <p id="representative" className="w100 h18 pl8 bn bb mb10 signatureClassOther font-20"
                                        > {`${adminData?.AEmployee?.firstName} ${adminData?.AEmployee?.lastName}`} </p>
                                    </td>
                                </tr>
                                {/* <tr className="w80 row" style={{ margin: 'auto' }}>
                                    <td className="w50 ">Employee Signature</td>
                                    <td className="w50 ">Company Representative</td>
                                </tr> */}
                            </tbody>
                        </table>
                        <table className="w100" style={{ marginTop: '20px' }}>
                            <tbody className="w100">




                                <tr className="w80 row" style={{ margin: 'auto' }}>
                                    <p style={{ width: '150px', marginTop: '10px' }}>Date Signature : </p>
                                    <td className="w50">
                                        <DatePicker
                                            // onChange={(e) => setFormData(prev => ({ ...prev, personPartTwo: { signatureDate: e } }))}
                                            onChange={(value) => setFormData(prev => ({ ...prev, signatureDate: value }))}

                                            value={formData?.signatureDate}
                                            disabled
                                            id="offerDate"
                                            className="datePickerReact mm w-80"

                                        />
                                    </td>
                                    {/* <p style={{ margin: 'auto' }}>Date</p> */}

                                </tr>
                                <tr className="w80 row" style={{ margin: 'auto' }}>
                                    {/* <td className="w60 ">Date Signature  */}
                                    {/* <input className="inp "/> */}
                                    {/* </td> */}

                                </tr>
                            </tbody>
                        </table>

                        <table className="w100 textCenter mt30">
                            <tbody className="w100">
                                <tr className="w100">
                                    <td className="w100" >Trans-Global Solutions, Inc.,</td>
                                    <td className="w100">1735 W. Cardinal Dr., Beaumont, Texas 77705</td>
                                    <td className="w100">Phone (409) 720-5413 – Fax (409) 729-7041</td>


                                </tr>
                            </tbody>
                        </table>
                        <table className="w100 mt20">
                            <tbody>
                                <tr> </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </table>
        </Grid>
    );

}
export default CompanyPropertyReturn;